import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserActions } from '../state/user'
import { State } from '../types/state'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'

export const FetchDataComponent = (): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()
  const { shouldRefreshUserState } = useSelector(
    (state: State) => state.refresh
  )

  const fetchUserData = async (): Promise<void> => {
    const username = localStorage.getItem('MyPath-usernmae')
    const password = localStorage.getItem('MyPath-password')
    const token = localStorage.getItem('MyPath-jwtToken')
    const googleToken = localStorage.getItem('MyPath-googleToken')

    if (token !== null) {
      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (username !== null && password !== null) {
      const tokenResponse = await requestMaker.getToken({
        username,
        password
      })
      localStorage.setItem('MyPath-jwtToken', tokenResponse.data.Authorization)

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (googleToken !== null) {
      const tokenResponse = await requestMaker.getToken({
        googleToken
      })
      localStorage.setItem('MyPath-jwtToken', tokenResponse.data.Authorization)

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    }
    dispatch(RefreshActions.setUserStateFetched())
  }

  useEffect(() => {
    if (shouldRefreshUserState) {
      void fetchUserData()
      dispatch(RefreshActions.setUserStateRefreshed())
    }
  }, [shouldRefreshUserState, fetchUserData])

  return <></>
}
